import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
    hzIncidents,
    IncidentDataTypes,
    IncidentItemType,
    IncidentsType,
    IncidentType,
} from "./IncidentsTypes";
import {
    AddressIcon,
    BackIcon,
    DeleteIcon,
    IconTimelineClock,
    QuickIncidentIcon,
} from "../iconSet/IconSet";
import ShowSlider from "./ReportIncidentsShowSlider";
import AlertDialog from "../popupComp/AlertDialog";
import LoadingScreen from "../loadingScreenComp/LoadingScreen";

const IncidentsNew = () => {

    const BASE_URL = process.env.REACT_APP_BASE_URL
    // Selected category
    const [selectedCategory, setSelectedCategory] =
        useState<IncidentType>("APPROVED");
    // Selected items using check box
    //const [selectedItems, setSelectedItems] = useState<string[]>([])
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const selectedItemRef = useRef<string[]>([]);
    const [hzIncidentsApproved, setHzincidentsApproved] = useState<hzIncidents[]>(
        []
    );
    const [hzIncidentsPending, setHzincidentsPending] = useState<hzIncidents[]>(
        []
    );
    const [hzIncidentsPendingGuest, setHzincidentsPendingGuest] = useState<hzIncidents[]>(
        []
    );

    const showAlertDialog = (
        title: string,
        description: string,
        yesCallback?: () => void,
        okCallback?: () => void
        ) => {
        setAlertTitle(title);
        setAlertDescription(description);
        setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
        setAlertOkCallback(() => okCallback);   // Will trigger only on OK
        setAlertDialogState(true);
    };

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

    const [clickedDetailsProd, setClickedDetailsProd] = useState<hzIncidents | null>(null);

    const [accessAreaCodes, setAccessAreaCodes] = React.useState<Set<string>>(new Set());

    // Handle category click
    const handleCategoryClick = (name: IncidentType) => {
        selectedItemRef.current = [];
        setSelectedCategory(name);
        setClickedDetailsProd(null);
    };

    // Handle item checkbox click
    const handleItemCheckClick = (
        event: ChangeEvent<HTMLInputElement>,
        id: string
    ) => {
        if (event.target.checked) {
            setSelectedItems((prev) => [...prev, id]);
        } else {
            setSelectedItems((prev) => prev.filter((item) => item !== id));
        }
    };

    // Handle click delete button
    const handleClickDeleteButton = () => {

        setSelectedItems([]);
    };


    const handleApproved = async (incidentId: string) => {
        const token = localStorage.getItem("access_token");
        if (!token) {
            throw new Error("Missing access token");
        }

        try {
            const URL = `${BASE_URL}/hz/api/v1/approvedIncidents`

            const formData = new URLSearchParams();
            formData.append('incd_id', incidentId);
            formData.append('token_id', token);

            const response = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData.toString()
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(
                    errorData.message ||
                    `Request failed with status ${response.status}`
                );
            }

            const responseData = await response.json();
            console.log("Approval successful:", responseData);
            window.location.reload()
            //return responseData;

        } catch (error) {
            console.error("Error approving incident:", error);
            throw error;
        }
    };

    const handleReject = async (incidentId: string) => {
        const token = localStorage.getItem("access_token");
        if (!token) {
            throw new Error("Missing access token");
        }

        try {
            const URL = `${BASE_URL}/hz/api/v1/removeIncidents`

            // Create form data to send as x-www-form-urlencoded
            const formData = new URLSearchParams();
            formData.append('incd_id', incidentId);
            formData.append('token_id', token);

            const response = await fetch(URL.toString(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData.toString()
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const responseData = await response.json();
            //console.log("Reject response:", responseData);
            window.location.reload()
            //return responseData;
        } catch (error) {
            console.error("Error rejecting incident:", error);
            throw error;
        }
    };

    const fetchDataApproved = async () => {
        const token = localStorage.getItem("access_token");
        if (!token) {
            throw new Error("Missing access token");
        }

        try {
            if (!hzIncidentsApproved || hzIncidentsApproved.length === 0) {
                const url = new URL(`${BASE_URL}/hz/api/v1/getListReportedIncidentAllApproved`);
                url.searchParams.append('token_id',
                    token
                );

                const response = await fetch(url.toString(), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                const responseData = await response.json();

                if (Array.isArray(responseData)) {
                    const data: hzIncidents[] = responseData;
                    setHzincidentsApproved(data);

                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const [isLoading, setIsLoading] = useState({
        pending: false,
        approved: false,
        guest: false
    });


    const fetchDataPending = async () => {
        const token = localStorage.getItem("access_token");
        if (!token) {
            throw new Error("Missing access token");
        }
        setIsLoading(prev => ({ ...prev, pending: true }));
        try {
            const url = new URL(`${BASE_URL}/hz/api/v1/getListReportedIncidentPendingApproved`);
            url.searchParams.append('token_id', token);
            const response = await fetch(url.toString(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();
            // Always set the state, even if empty array
            setHzincidentsPending(Array.isArray(responseData) ? responseData : []);

        } catch (error) {
            console.error("Error fetching data:", error);
            // Set empty array on error too
            setHzincidentsPending([]);
        } finally {
            setIsLoading(prev => ({ ...prev, pending: false }));
        }

    };

    const fetchAccessArea = async () => {
        const token = localStorage.getItem("access_token");
        if (!token) {
            throw new Error("Missing access token");
        }

        try {
            const url = `${BASE_URL}/identity_manager/api/v1/getUserAreas`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }

            const decodedResponse = await response.json();

            const dataList = decodedResponse.data;
            if (Array.isArray(dataList)) {
                const newSet = new Set(dataList.map((item: any) => item.toString()));
                setAccessAreaCodes(newSet);

            } else {
                console.warn("Unexpected response format:", decodedResponse);
            }

        } catch (error) {
            console.error("Error fetching access codes:", error);
        }
    };

    const fetchDataPendingGuest = async () => {
        const token = localStorage.getItem("access_token");
        if (!token) {
            throw new Error("Missing access token");
        }

        try {
            if (!hzIncidentsPendingGuest || hzIncidentsPendingGuest.length === 0) {
                const url = new URL(`${BASE_URL}/hz/api/v1/getPendingListReported`);
                url.searchParams.append('token_id',
                    token
                );

                const response = await fetch(url.toString(), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                const responseData = await response.json();

                if (Array.isArray(responseData)) {
                    //console.log("API Response:", responseData);
                    let filteredData: hzIncidents[] = [];
                    if (accessAreaCodes.has("MV")) {
                        filteredData = responseData;
                    } else {
          //console.log("------111111---------", accessAreaCodes);
          //console.log("------response data---------", responseData);
          filteredData = responseData.filter((item: any) => {
            const code = String(item.active_pcode).trim();
            return Array.from(accessAreaCodes).some(
                (a) => code.startsWith(String(a).trim())
            );
          });
          //console.log("-------filteredData----------", filteredData);
        }
                    
                    setHzincidentsPendingGuest(filteredData);
                    // const data: hzIncidents[] = responseData;
                    // setHzincidentsPendingGuest(data);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchDataApproved();
        fetchDataPending();
       fetchDataPendingGuest();
        fetchAccessArea();
    }, []);

    useEffect(() => { }, [hzIncidentsApproved]);
    useEffect(() => { }, [hzIncidentsPending]);
    useEffect(() => { }, [hzIncidentsPendingGuest]);
    useEffect(() => {
       fetchDataPendingGuest();
    }, [accessAreaCodes]);

    return (
        <div className={`container-wrapper`} style={{ height: "100%" }}>
            <span className={`title`}>incidents</span>

            {/* Incident */}
            <div className={`incident-wrapper`}>
                <div className={`side-wrapper`}>
                    <div
                        className={"side-button"}
                        style={{
                            backgroundColor:
                                selectedCategory === "APPROVED" ? "var(--color-accent-bg)" : "",
                        }}
                        onClick={() => handleCategoryClick("APPROVED")}
                    >
                        <span
                            className={`name`}
                            style={{
                                color:
                                    selectedCategory === "APPROVED"
                                        ? "var(--color-main-white)"
                                        : "",
                            }}
                        >
                            approved
                        </span>
                        <span
                            className={`count`}
                            style={{
                                color:
                                    selectedCategory === "APPROVED"
                                        ? "var(--color-main-white)"
                                        : "",
                            }}
                        >
                            {hzIncidentsApproved.length}
                        </span>
                    </div>
                    <div
                        className={"side-button"}
                        style={{
                            backgroundColor:
                                selectedCategory === "PENDING" ? "var(--color-accent-bg)" : "",
                        }}
                        onClick={() => handleCategoryClick("PENDING")}
                    >
                        <span
                            className={`name`}
                            style={{
                                color:
                                    selectedCategory === "PENDING"
                                        ? "var(--color-main-white)"
                                        : "",
                            }}
                        >
                            pending
                        </span>
                        <span
                            className={`count`}
                            style={{
                                color:
                                    selectedCategory === "PENDING"
                                        ? "var(--color-main-white)"
                                        : "",
                            }}
                        >
                            {hzIncidentsPending.length}
                        </span>
                    </div>
                    <div
                        className={"side-button"}
                        style={{
                            backgroundColor:
                                selectedCategory === "PENDING_BY_GUEST"
                                    ? "var(--color-accent-bg)"
                                    : "",
                        }}
                        onClick={() => handleCategoryClick("PENDING_BY_GUEST")}
                    >
                        <span
                            className={`name`}
                            style={{
                                color:
                                    selectedCategory === "PENDING_BY_GUEST"
                                        ? "var(--color-main-white)"
                                        : "",
                            }}
                        >
                            pending incident by guest
                        </span>
                        <span
                            className={`count`}
                            style={{
                                color:
                                    selectedCategory === "PENDING_BY_GUEST"
                                        ? "var(--color-main-white)"
                                        : "",
                            }}
                        >
                            {hzIncidentsPendingGuest.length}
                        </span>
                    </div>
                </div>
                <div className={`data-wrapper`}>
                    <div className={`header-wrapper`}>
                        {clickedDetailsProd === null && (
                            <div
                                className={`icon-wrapper`}
                                onClick={() => handleClickDeleteButton()}
                            >
                                {/* <DeleteIcon width="1rem" color="var(--color-text)" /> */}
                            </div>
                        )}
                        {clickedDetailsProd !== null && (
                            <>
                                <div
                                    className={`icon-wrapper`}
                                    onClick={() => setClickedDetailsProd(null)}
                                >
                                    <BackIcon width="1rem" color="var(--color-text)" />
                                </div>
                                <span className="header-title">
                                    {selectedCategory}: {clickedDetailsProd.w_name}
                                </span>
                            </>
                        )}
                    </div>
                    <div className={`data-wrapper`}>
                        {clickedDetailsProd === null ? (
                            <>
                                {selectedCategory === "APPROVED" &&
                                    hzIncidentsApproved

                                        .map((data, index) => (
                                            <div className={`item-wrapper`} key={index}>
                                                {/* <input
                                                    type="checkbox"
                                                    name={data.w_id}
                                                    checked={selectedItems.includes(data.w_id)}
                                                    onChange={(e) => handleItemCheckClick(e, data.w_id)}
                                                /> */}
                                                <QuickIncidentIcon width='1.5rem' color='var(--color-text)'/>
                                                <span
                                                    className={`name`}
                                                    onClick={() => setClickedDetailsProd(data)}
                                                >
                                                    {data.w_name}:
                                                </span>
                                                <span
                                                    className={`description`}
                                                    onClick={() => setClickedDetailsProd(data)}
                                                >
                                                    {data.w_desc}
                                                </span>
                                            </div>
                                        ))}
                                {selectedCategory === "PENDING" &&
                                    hzIncidentsPending

                                        .map((data, index) => (
                                            <div className={`item-wrapper`} key={index}>
                                                {/* <input
                                                    type="checkbox"
                                                    name={data.w_id}
                                                    checked={selectedItems.includes(data.w_id)}
                                                    onChange={(e) => handleItemCheckClick(e, data.w_id)}
                                                /> */}
                                                <span
                                                    className={`name`}
                                                    onClick={() => setClickedDetailsProd(data)}
                                                >
                                                    {data.w_name}:
                                                </span>
                                                <span
                                                    className={`description`}
                                                    onClick={() => setClickedDetailsProd(data)}
                                                >
                                                    {data.w_desc}
                                                </span>
                                            </div>
                                        ))}
                                {selectedCategory === "PENDING_BY_GUEST" &&
                                    hzIncidentsPendingGuest

                                        .map((data, index) => (
                                            <div className={`item-wrapper`} key={index}>
                                                {/* <input
                                                    type="checkbox"
                                                    name={data.w_id}
                                                    checked={selectedItems.includes(data.w_id)}
                                                    onChange={(e) => handleItemCheckClick(e, data.w_id)}
                                                /> */}
                                                <span
                                                    className={`name`}
                                                    onClick={() => setClickedDetailsProd(data)}
                                                >
                                                    {data.w_name}:
                                                </span>
                                                <span
                                                    className={`description`}
                                                    onClick={() => setClickedDetailsProd(data)}
                                                >
                                                    {data.w_desc}
                                                </span>
                                            </div>
                                        ))}
                            </>
                        ) : (
                            <div className={`item-details-wrapper`}>
                                <div className="title">
                                    <span className="title-name">{clickedDetailsProd!.w_name}</span>
                                    <span className="title-des">{clickedDetailsProd!.w_desc}</span>
                                </div>
                                <div className="item-details-container">
                                    <div className="time-wrapper">
                                        <div className="field-wrapper">
                                            <AddressIcon width="1rem" color="var(--color-text)" />
                                            <span>
                                                {clickedDetailsProd!.adm3_en},
                                                {clickedDetailsProd!.adm2_en}, {clickedDetailsProd!.adm1_en}
                                            </span>
                                        </div>
                                        <div className="field-wrapper">
                                            <IconTimelineClock
                                                width="1rem"
                                                color="var(--color-text)"
                                            />
                                            <div>
                                                <span>
                                                    Occurred date: {clickedDetailsProd!.observed_date || "N/A"}
                                                </span>
                                                <span>
                                                    Issued date: {clickedDetailsProd!.issued_time || "N/A"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="details-wrapper">
                                        <span className="details-title">Impact</span>

                                        {clickedDetailsProd!.imp_human !== "" && (
                                            <span className="details-text">
                                                People affected:  {clickedDetailsProd!.imp_human}
                                            </span>
                                        )}
                                        {clickedDetailsProd!.impdes_human !== "" && (
                                            <span className="details-text" style={{ paddingBottom: "5px" }}>
                                                More description: {clickedDetailsProd!.impdes_human}
                                            </span>
                                        )}

                                        {clickedDetailsProd!.imp_house !== "" && (
                                            <span className="details-text">
                                                House damage: {clickedDetailsProd!.imp_house}
                                            </span>
                                        )}
                                        {clickedDetailsProd!.impdes_house !== "" && (
                                            <span className="details-text" style={{ paddingBottom: "5px" }}>
                                                More description:{clickedDetailsProd!.impdes_house}
                                            </span>
                                        )}

                                        {clickedDetailsProd!.imp_roadblock !== "" && (
                                            <span className="details-text">
                                                Road block: {clickedDetailsProd!.imp_roadblock}
                                            </span>
                                        )}
                                        {clickedDetailsProd!.impdes_roadblock !== "" && (
                                            <span className="details-text" style={{ paddingBottom: "5px" }}>
                                                More description: {clickedDetailsProd!.impdes_roadblock}
                                            </span>
                                        )}

                                        {clickedDetailsProd!.imp_roaddamage !== "" && (
                                            <span className="details-text">
                                                Road damage: {clickedDetailsProd!.imp_roaddamage}
                                            </span>
                                        )}
                                        {clickedDetailsProd!.impdes_roaddamage !== "" && (
                                            <span className="details-text" style={{ paddingBottom: "5px" }}>
                                                More description: {clickedDetailsProd!.impdes_roaddamage}
                                            </span>
                                        )}

                                        {clickedDetailsProd!.imp_electricity !== "" && (
                                            <span className="details-text">
                                                Electricity: {clickedDetailsProd!.imp_electricity}
                                            </span>
                                        )}
                                        {clickedDetailsProd!.impdes_electricity !== "" && (
                                            <span className="details-text" style={{ paddingBottom: "5px" }}>
                                                More description: {clickedDetailsProd!.impdes_electricity}
                                            </span>
                                        )}
                                        {clickedDetailsProd!.imp_water !== "" && (
                                            <span className="details-text">
                                                Water supply: {clickedDetailsProd!.imp_water}
                                            </span>
                                        )}
                                        {clickedDetailsProd!.impdes_water !== "" && (
                                            <span className="details-text" style={{ paddingBottom: "5px" }}>
                                                More description: {clickedDetailsProd!.impdes_water}
                                            </span>
                                        )}

                                        {clickedDetailsProd!.imp_communication !== "" && (
                                            <span className="details-text">
                                                Communication:  {clickedDetailsProd!.imp_communication}
                                            </span>
                                        )}
                                        {clickedDetailsProd!.impdes_communication !== "" && (
                                            <span className="details-text" style={{ paddingBottom: "5px" }}>
                                                More description: {clickedDetailsProd!.impdes_communication}
                                            </span>
                                        )}

                                        <span className="details-title">Images</span>
                                        <div className="image-box" style={{
                                            height: "300px"
                                        }}>
                                            <ShowSlider img_url={clickedDetailsProd!.img_url} w_id={clickedDetailsProd!.w_id} />

                                        </div>
                                        
                                        {(selectedCategory === "PENDING" ||
                                            selectedCategory === "PENDING_BY_GUEST") && (
                                                <div className="button-wrapper">
                                                    <button
                                                        style={{ backgroundColor: "var(--color-main-red)" }}
                                                        onClick={(e) => 
                                                            showAlertDialog(
                                                                "Confirm Reject",
                                                                "Are you sure you want to reject this incident?",
                                                                () => handleReject(clickedDetailsProd!.w_id), undefined)
                                                        }
                                                    >
                                                        reject
                                                    </button>
                                                    <button
                                                        style={{ backgroundColor: "var(--color-main-green)" }}
                                                        onClick={(e) => 
                                                            showAlertDialog(
                                                                "Confirm Submit",
                                                                "Are you sure you want to approve this incident?",
                                                                () => handleApproved(clickedDetailsProd!.w_id))
                                                            }
                                                    >
                                                        approve
                                                    </button>
                                                </div>
                                        )}
                                        {selectedCategory === 'APPROVED' && (
                                            <div className="button-wrapper">
                                                <button
                                                    style={{ backgroundColor: "var(--color-main-red)" }}
                                                    onClick={(e) => 
                                                        showAlertDialog(
                                                            "Confirm Reject",
                                                            "Are you sure you want to reject this incident?",
                                                            () => handleReject(clickedDetailsProd!.w_id), undefined)
                                                    }
                                                >
                                                    delete
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {alertDialogState && (
                <AlertDialog
                    title={alertTitle}
                    description={alertDescription}
                    windowState={alertDialogState}
                    setWindowState={setAlertDialogState}
                    function={alertYesCallback}
                    okFunction={alertOkCallback}
                />
            )}
            {/* {isLoading && (
                <LoadingScreen />
            )} */}
        </div>
    );
};

export default IncidentsNew;
